<template>
    <div class="autoenrolments__add">
        <div class="autoenrolments__add_header">
            <view-actions
                :breadcrumb-active="true"
                :breadcrumb-items="[
                    {
                        name: 'Auto-enrolments',
                        to: { name: 'ebs-autoenrolments-list' }
                    }
                ]"
                :cancel-notify-active="true"
                :notify-title="'auto-enrolment'"
                :notify-process="'stop adding'"
                :title="'Create auto-enrolment'"
                :submit-button-animate-loading="true"
                :submit-button-animate-loading-event-name="'submit-autoenrolments'"
                @emit-submit="performSubmitValidate"
                @emit-notify-cancel-submit="autoenrolmentStopAdd"
            />
        </div>
        <div class="autoenrolments__add_main">
            <div class="container">
                <div class="columns">
                    <div class="column">
                        <autoenrolments-edit-form></autoenrolments-edit-form>
                    </div>
                </div>
            </div>
        </div>
        <pop-notify
            ref="popnotifyvalidation"
            :class="'pop__notify--validation'"
            :title-text="`Something's not quite right`"
            :content-text="'Please check that you have filled out all the fields in the form correctly and try again.'"
            :cancel-button-text="'Ok'"
            :submit-button-active="false"
        />
    </div>
</template>

<script>
import ViewActions from '@/components/default/shared/ViewActions'
import PopNotify from '@/components/default/shared/PopNotify'
import { validateBeforeRouteLeave, performSubmitValidate } from '@/helpers/mixins'
import { User } from '@/User'
import AutoenrolmentsEditForm from '@/components/ebs/autoenrolments/edit/AutoenrolmentsEditForm'

export default {
  components: {
    AutoenrolmentsEditForm,
    PopNotify,
    ViewActions
  },
  name: 'autoenrolments-add',
  data () {
    return {
      user: new User()
    }
  },
  mixins: [validateBeforeRouteLeave, performSubmitValidate],
  computed: {
    rootItemName () {
      return 'autoenrolments'
    },
    routeQueryView () {
      return this.$route.query.view
    },
    nameActionCreate () {
      return 'lmsUserAutoenrolmentCreate'
    }
  },
  methods: {
    performSubmitValidateThenCallback () {
      this.$router.push({ name: 'ebs-autoenrolments-list', query: { view: this.routeQueryView } })
    },
    performSubmitValidateFinallyCallback () {
      this.$eventBus.$emit('stop-submit-autoenrolments')
    },
    performSubmitValidateValidationCallback () {
      this.$eventBus.$emit('stop-submit-autoenrolments')
    },
    autoenrolmentStopAdd () {
      this.$router.push({ name: 'ebs-autoenrolments-list' })
    }
  },
  provide () {
    return {
      $validator: this.$validator
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/autoenrolments/autoenrolmentsaddedit";
</style>
